import React, { Component } from 'react';
import MessageInput from './MessageInput/MessageInput';
import { SEEK_VALUE, PATH } from '../../../../../../constants';
import './MessageBlock.css';
import { TEXT } from '../../../../../../content';

// note - probably split to input + video controls

class MessageBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
    };

    this.handleChangeMessage = this.handleChangeMessage.bind(this);
    this.handleSend = this.handleSend.bind(this);
  }

  // -----------------------------------------------------------------------------------
  // Reset
  // -----------------------------------------------------------------------------------

  resetMessage() {
    this.setState({
      message: '',
    });
  }

  // -----------------------------------------------------------------------------------
  // Handlers
  // -----------------------------------------------------------------------------------

  handleChangeMessage(message) {
    this.setState({
      message,
    });
  }

  handleSend() {
    const { formSend } = this.props;
    const { message } = this.state;
    formSend(message);
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  render() {
    const { message } = this.state;
    const {
      videoControls,
      videoStarted,
      videoPlaying,
      onVideoSwitch,
      onVideoPause,
      onVideoSeek,
    } = this.props;

    return (
      <div id="message-form">
        <img
          id="mf-title"
          src={`${PATH.IMG}title/poznavate.png`}
          alt={TEXT.MESSAGES_TITLE}
        />

        <div id="mf-wrap">
          <MessageInput
            videoPause={onVideoPause}
            messageUpdate={this.handleChangeMessage}
            messageSend={this.handleSend}
            message={message}
          />

          {videoControls && (
            <div id="vc-wrap">
              <div id="vc-wrap-in">
                {videoStarted && (
                  <button
                    className="vp-seek left"
                    type="button"
                    onClick={() => onVideoSeek(true, -SEEK_VALUE)}
                  >
                    <img alt="" src={`${PATH.IMG}ico/seek-m.png`} />
                  </button>
                )}
                <button
                  id="video-play-switch"
                  type="button"
                  onClick={onVideoSwitch}
                >
                  <img
                    className={`vpsi-ico ${videoPlaying ? 'hide' : ''}`}
                    alt=""
                    src={`${PATH.IMG}ico/play.png`}
                  />
                  <img
                    className={`vpsi-ico ${videoPlaying ? '' : 'hide'}`}
                    alt=""
                    src={`${PATH.IMG}ico/pause.png`}
                  />
                </button>
                {videoStarted && (
                  <button
                    className="vp-seek right"
                    type="button"
                    onClick={() => onVideoSeek(true, SEEK_VALUE)}
                  >
                    <img alt="" src={`${PATH.IMG}ico/seek-p.png`} />
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MessageBlock;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/MessageBlock/MessageBlock.js